import React from "react";
import InitializePage from '../../lib/server/page'
import { useRouter } from 'next/router'
import Link from "next/link";
import { getWebTexts } from '../../lib/api/common.jsx';
import { textsWeb, getText } from '../../lib/utils/langTexts'
import Header from "../../components/Layouts/Header";
import HomeFooter from '../../components/Layouts/HomeFooter.jsx';
import SubscribeNewsLetter from '../../components/common/subscribenewsletter.jsx';
import HeaderTag from '../../components/meta.jsx';


const Neustradistribution = ({webTexts, menu}) => {
  const router = useRouter()

  let hidenavbar = true;

  if(router.pathname ==  '/history' || router.pathname ==  '/contacto') {
    hidenavbar = false;
  }

  return (
    <>
        <Header page={'common'} menuSections={menu}/>
        <HeaderTag title="Eccediciones" description="eccediciones" />
            <div className="container innerpage main-container mt-50 static distribucion ckeditor" dangerouslySetInnerHTML={{ __html:webTexts.find(x=> x.webCode=="DIST001")?.webText}}></div>

            {/*<div className="container innerpage main-container mt-60 static distribucion">
                <h2 className="A-la-venta-esta-sema">{webtexts.find(x=> x.webCode=="distribucion-001")?.webText}</h2>
                <div className="line4"></div>
                <h6 className="subheading">
                    {webtexts.find(x=> x.webCode=="distribucion-002")?.webText}
                </h6>
                <div dangerouslySetInnerHTML={{ __html:webtexts.find(x=> x.webCode=="distribucion-003")?.webText}}></div>
                <div className="contacts">
                    <p><b>Contacto españa:</b>   comercial@eccediciones.com</p>
                    <p><b>Contacto sudamérica:</b>  comercial.sudamerica@eccediciones.com</p>
                </div>
                <h6 className="subheading">Si ya eres cliente puedes acceder a tu cuenta aquí:</h6>
                <div className="links nomargin">
                    <ul>
                        <li><Link href="#">Acceso clientes</Link></li>
                    </ul>
                </div>
                <div dangerouslySetInnerHTML={{ __html:webtexts.find(x=> x.webCode=="distribucion-004")?.webText}}></div>
            </div>
            <div className="container main-container innersec_images1 static">
                <img src="https://content.eccediciones.com/web-assets/Distribucion_red.jpg" alt=""/>
                <p><i>Batman.</i></p>
            </div>*/}
            {/*<div className="clearfix"></div>
            <div className="container main-container innerpage static mb-80">
                <p>Phasellus quis lectus velit. Sed placerat neque eu ex pretium commodo. Vestibulum dapibus maximus accumsan. Phasellus vitae elit id lacus sagittis egestas. Duis pharetra euismod fermentum. Ut egestas diam vel turpis commodo maximus. Vivamus vel laoreet ex. Maecenas sagittis laoreet dui at consequat.</p>
                <p>Nullam sit amet porttitor magna. Phasellus eget risus ac est accumsan lacinia nec vitae elit. Suspendisse sit amet imperdiet leo. Donec venenatis ornare sem at sodales. Curabitur ac odio vitae nibh iaculis cursus. Nullam vehicula ligula felis. Fusce non mauris non arcu convallis mattis vel ac lacus. Integer ut eleifend leo, ac condimentum arcu. Curabitur ac luctus dui. Aliquam eu bibendum ligula. Ut at pulvinar lorem, in sagittis velit. Morbi dapibus nunc libero, vitae luctus lacus scelerisque sit amet. Ut varius pretium tincidunt. Pellentesque sollicitudin justo et diam feugiat tempus. Donec aliquam tempus fermentum. Fusce velit nisi, congue non pretium at, viverra at ligula.</p>
                <p>
                    Fusce feugiat ornare condimentum. Aliquam molestie, nisi quis laoreet vehicula, dui libero varius diam, ut euismod libero purus id eros. Praesent a elit est. Ut sit amet volutpat elit. Suspendisse eu bibendum erat. Proin felis enim, accumsan sit amet lobortis eget, congue sed turpis. Ut velit nisi, vulputate non commodo vitae, egestas quis urna.
                </p>
            </div>*/}
            <div className="container line-container">
              <div className="line6"></div>
            </div>
            <SubscribeNewsLetter webTexts={webTexts} />
    <HomeFooter />
    </>
  );
};

async function loadData(context){
    
    const webtexts = await getWebTexts(textsWeb.distribucion);

    return {webTexts:webtexts?.data}
}
export async function getStaticProps(context) {
    return InitializePage(context,loadData, true)
}



export default Neustradistribution;
